// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"Table_tableWrapper__Ot-RM","col":"Table_col__2sgZK","fulfillmentStatus":"Table_fulfillmentStatus__3-Kio","emailCol":"Table_emailCol__q3MK_"};